import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue';
import { useDonationFormsStore } from '../../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingInfo',
  props: ['is_logged_in', 'email', 'strings'],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;

const setValue = (key, val) => {
  store[key] = val;
};
const setBillingValue = (key, val) => {
  store.billing_fields[key] = (val.target as HTMLInputElement).value;
};
const trans = (key) => {
  if(props.strings) {
    return props.strings[key]
  }
};

onMounted(() => {
  if(props.is_logged_in && props.email) {
      store.billing_fields.email = props.email;
    }
});



const __returned__ = { store, props, setValue, setBillingValue, trans }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})